import React from 'react';
import { Box, Dialog } from '@mui/material';

import ButtonK from '../Button/ButtonK';

export const AlertDialog = ({
  open,
  logoSrc,
  title,
  description,
  onYesClick,
  onNoClick,
}) => {
  return (
    <Dialog
      open={open}
      PaperProps={{
        style: {
          // width: '20%',
          // padding: '25px',
          borderRadius: '20px',
          textAlign: 'center',
          // height: '400px',
          // Additional styles as needed
        }
      }}
      style={{
        // width: '500px',
        padding: '25px',
        // borderRadius: '20px !important',
        textAlign: 'center',
        position: 'absolute',
        top: '15%',
        // left: '0%',
        height:'400px',

        // transform: 'translate(-50%, -50%)',
      }}
    >
      <Box sx={{padding:'10px'}}>
      <img src={logoSrc} alt="logo" style={{ marginBottom: '16px',height:'45px',width:'40px',margin:'0 auto'}} />
      <Box sx={{ color: '#131F32', fontSize: '16px', fontWeight: '600' }}>
        {title}
      </Box>
      <Box sx={{ color: '#131F32', fontSize: '12px', fontWeight: '500' }}>
        {description}
      </Box>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center', // Center the buttons
          marginBottom: '8px', // Add some space between the buttons and text
        }}
      >
        <ButtonK
          text="Yes"
          color="#FC5454"
          variant="outlined"

          handleClick={onYesClick}
          sx={{ width: '30%', border: '1px solid #FC5454',height:'30px',textTransform:'capitalize'}}
        />
        <Box sx={{ width: '16px' }} /> {/* Add some space between the buttons */}
        <ButtonK
          text="No, I don't want to"
          color="#131F32"
          backgroundColor="#FFD600"
          variant="filled"
          handleClick={onNoClick}
          sx={{ width: '60%',height:'30px',textTransform:'capitalize'  }}
        />
      </Box>
      </Box>
    </Dialog>
  );
};

export default AlertDialog;
